<template>
  <div class="registration-header" :class='{ full: !showCloseButton }'>
    <span class="header-title part"> {{ title }}</span>
    <div class="header-logo-container part">
      <company-logo v-if="getUrl" :domain="getUrl" view="register"/>
      <img src="../../assets/icons/whitelabeling/cynergy.app/cynergy_app_no_text.svg" v-else/>
    </div>
    <div class="header-button-container part">
      <div v-if="showCloseButton" class="header-button" @click="onCloseClickButton">
        <span class="cross-symbol"> X </span>
        <span> {{ $t('newProject.esc') }} </span>
      </div>
    </div>
  </div>
</template>

<script>
import CompanyLogo from '@/components/common/CompanyLogo.vue';

export default {
  name: 'RegistrationHeader',
  components: { CompanyLogo },
  props: {
    showCloseButton: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
  },
  methods: {
    onCloseClickButton() {
      this.$emit('close');
    },
  },
  computed: {
    getUrl() {
      const url = window.location.href;
      if (url.includes('localhost')) {
        return null;
      }
      const protocol = url?.split('://')[0];
      const domain = url?.split('://')[1].split('/')[0];
      return `${protocol}://${domain}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.part {
  flex: 1;
}

.registration-header {
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  width: 70%;
  padding: 0 rem(110);
  margin-left: auto;
  margin-right: auto;
}

.full {
  width: 100%;
}

.header-title {
  color: #b9c6d1;
  font-size: rem(20);
  font-family: $font-family-black;
  font-weight: 900;
  letter-spacing: 0;
  line-height: rem(24);
  padding: rem(24) 0;
}

.header-logo-container {
  padding: rem(14) 0;
  display: flex;
  justify-content: center;

  img {
    max-height: rem(45);
    margin-top: rem(5);
  }
}

.header-button-container {
  display: flex;
  justify-content: flex-end;
  padding: rem(28) 0;

  .header-button {
    display: flex;
    align-items: center;
    cursor: pointer;
    color: #8f24d0;
    font-size: rem(12);
    font-weight: 500;
    letter-spacing: rem(1.07);
    line-height: rem(16);

    .cross-symbol {
      font-size: rem(20);
      padding-right: rem(10);
    }
  }
}
</style>
